// Action Types
export const FETCH_DYNAMIC_TABS_REQUEST = "FETCH_DYNAMIC_TABS_REQUEST";
export const FETCH_DYNAMIC_TABS_SUCCESS = "FETCH_DYNAMIC_TABS_SUCCESS";
export const FETCH_DYNAMIC_TABS_FAILURE = "FETCH_DYNAMIC_TABS_FAILURE";

// Action Creators
export const fetchDynamicTabsRequest = (params) => {
  return (dispatch) => {
    dispatch({
      type: FETCH_DYNAMIC_TABS_REQUEST,
      payload: params,
    });
  };
};
export const fetchDynamicTabsSuccess = (data) => ({
  type: FETCH_DYNAMIC_TABS_SUCCESS,
  payload: data,
});
export const fetchDynamicTabsFailure = (error) => ({
  type: FETCH_DYNAMIC_TABS_FAILURE,
  payload: error,
});
